import React from "react";

import { useBaseTabsContext } from "../BaseTabs";

import { PanelHeader } from "./PanelHeader";
import { PanelList } from "./PanelList";
import { TabPanel } from "./TabPanel";

const BaseTabPanelContext = React.createContext(null);

export const useBaseTabPanelContext = () => {
  const context = React.useContext(BaseTabPanelContext);

  if (!context) throw new Error("BaseTabPanel Context not provided!");

  return context;
};

export const BaseTabPanel = ({ children, value }) => {
  const { activeTab } = useBaseTabsContext();

  const [state, dispatch] = React.useReducer(
    (prev, next) => ({ ...prev, ...next }),
    {
      availableItems: [],
      selectedItems: [],
    }
  );

  // methods
  const onSelectAll = React.useCallback(() => {
    if (state?.selectedItems?.length === state.availableItems?.length)
      return dispatch({ selectedItems: [] });

    return dispatch({ selectedItems: state.availableItems });
  }, [state]);

  return (
    <BaseTabPanelContext.Provider value={{ state, dispatch, onSelectAll }}>
      <TabPanel {...{ activeTab, value }}>{children}</TabPanel>
    </BaseTabPanelContext.Provider>
  );
};

BaseTabPanel.Header = PanelHeader;

BaseTabPanel.List = PanelList;
